import { createPortal } from 'react-dom';
import { selectModalList } from '../../features/modalSlice';

import { useAppSelector } from '../../hooks/useRedux';

import { ModalComponents } from '../../types/modal';

import Account from './Account';
import Notification from './Notification';
import Confirm from './Confirm';
import Alert from './Alert';
import HtmlContent from './HtmlContent';
import { UploadLibrary, UploadDrive } from '../Upload';
import SliderModal from '../SliderModal';
import DynamicModal from './DynamicModal';
import { selectMenu } from '../../features/infoSlice';

export default function ModalContainer() {
  const modalList = useAppSelector(selectModalList);
  const menu = useAppSelector(selectMenu);

  const ModalList: ModalComponents = {
    notification: Notification,
    account: Account,
    confirm: Confirm,
    alert: Alert,
    content: HtmlContent,
    upload:
      menu === 'library' ||
      modalList.find(({ name }) => name === 'upload-library')
        ? UploadLibrary
        : UploadDrive,
    slider: SliderModal,
    component: DynamicModal,
  };

  return createPortal(
    modalList.map(
      ({
        name,
        id,
        type,
        subKey,
        initialButtonDisabled,
        isOpen,
        isHidden = false,
        data,
        contentTitle,
      }) => {
        const ModalComponent = ModalList[type];
        return isOpen ? (
          <ModalComponent
            key={id}
            name={name}
            id={id}
            type={type}
            subKey={subKey}
            initialButtonDisabled={initialButtonDisabled}
            data={data}
            isHidden={isHidden}
            contentTitle={contentTitle}
          />
        ) : null;
      }
    ),
    document.getElementById('modal') as HTMLElement
  );
}
